import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogAction from "./components/dialogAction";
import SlidesContainer from "./components/slidesContainer";
import { withStyles } from "@material-ui/core";
import { styles } from "./style";
import { getSlides } from "./Slides";

const SlidesDialog = ({ classes, showSlides, handleCloseCallBack, appName }) => {
  const [open, setOpen] = React.useState(showSlides);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  React.useEffect(() => {
    setOpen(showSlides);
    setCurrentSlide(0);
  }, [showSlides]);

  const handlePrevClick = () => {
    setCurrentSlide(currentSlide - 1);
  };

  const handleNextClick = () => {
    setCurrentSlide(currentSlide + 1);
  };

  const handleClick = (index) => {
    setCurrentSlide(index);
  };

  const handleToggleDrawer = () => {
    setOpen(!open);
    handleCloseCallBack();
  };

  const slides = getSlides(classes, appName);

  return (
    <>
      {/* <div onClick={handleToggleDrawer}>Click</div> */}
      <Dialog
        open={open}
        onClose={() => { }}
        PaperProps={{
          classes: {
            rounded: classes.root,
          },
        }}
      >
        {open && <>
          <SlidesContainer
            slides={slides}
            currentSlide={currentSlide}
            classes={classes}
            handleToggleDrawer={handleToggleDrawer}
          />
          <DialogAction
            classes={classes}
            currentSlide={currentSlide}
            handleNextClick={handleNextClick}
            handlePrevClick={handlePrevClick}
            handleClick={handleClick}
            slides={slides.map((item, index) => index)}
          />
        </>}
      </Dialog>
    </>
  );
};

export default withStyles(styles)(SlidesDialog);